import React, { Fragment } from 'react'
import { host } from '../../../../../../../configuraciones';
import ModalMensajeComponent from './ModalMensajeComponent';
import { library } from '@fortawesome/fontawesome-svg-core'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
library.add(faFileInvoice)
import estilos from '../../../../../UsuarioNacional/SolicitudesOrganismoComponent.module.css'
function BotonVerArchivo01Component(props) {
    const [openModal, setOpenModal] = React.useState(false)
    const verArchivo = async () => {
        const fileFetch = await fetch(host + `${props.url}`,{
            method: 'GET',
            headers:{
                'authorization':localStorage.getItem('user'),
                'refresh-authorization': localStorage.getItem('refreshToken'),
                'Content-Type': 'application/json'
            },
        })
        if (fileFetch.status != 404) {
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(url);
        } else {
            setOpenModal(true)
        }
    };
    return (
        <Fragment>
            <button onClick={() => verArchivo()} className={`btn ${estilos.btnAzul}`} ><VisibilityRoundedIcon style={{ transform: 'scale(1.5)' }} icon={faFileInvoice} /></button>
            { openModal &&
                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonVerArchivo01Component